import { z } from "zod";
import { cents, dateStr, flag, id, instantDateTime, nonNegativePct, nullableText } from "./common";

export const commissionBasis = z.enum(["booker", "venue_all"]);
export const commissionOn = z.enum(["total", "subtotal"]);
export const commissionStatus = z.enum(["payable", "paid", "void"]);
export const commissionRate = nonNegativePct;
const commissionRateText = z.string().refine(value => commissionRate.safeParse(value).success, "Commission rate must be non-negative finite decimal text");

export const commissionRuleRecord = z.object({
  memberId: id,
  venueId: id.nullable().optional(),
  basis: commissionBasis,
  ratePct: commissionRateText,
  on: commissionOn,
  active: flag.optional(),
  effectiveFrom: dateStr.nullable().optional(),
});
export const commissionRuleInput = commissionRuleRecord.extend({ on: commissionOn.default("total"), ratePct: commissionRate });
export type CommissionRuleInput = z.infer<typeof commissionRuleInput>;
export const commissionRulePatch = commissionRuleRecord.partial().extend({ ratePct: commissionRate.optional() });
export type CommissionRulePatch = z.infer<typeof commissionRulePatch>;

export const commissionEntriesQuery = z.object({ memberId: id.optional(), status: commissionStatus.optional(), bookingId: id.optional() });

/** Raw ledger inspection keeps nullable legacy links, without create defaults. */
export const commissionEntryRecord = z.object({
  bookingId: id.nullable().optional(), paymentId: id.nullable().optional(), memberId: id.nullable().optional(), ruleId: id.nullable().optional(), refundOfEntryId: id.nullable().optional(),
  basisAmount: cents, ratePct: commissionRateText, amount: cents, status: commissionStatus,
  paidAt: instantDateTime.nullable().optional(), payoutRef: z.string().max(200).nullable().optional(), notes: nullableText.optional(),
});
